import { useAuth } from '@/app/context';
import { useEffect, useState } from 'react';

export function useIsBrokerUser() {
  const { checkUserGroups } = useAuth();
  const [isBrokerUser, setIsBrokerUser] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const check = async () => {
      setIsLoading(true);
      const result = await checkUserGroups(['broker.broker', 'broker.master']);
      setIsBrokerUser(result);
      setIsLoading(false);
    };

    check();
  }, [checkUserGroups]);

  return { isBrokerUser, isLoading };
}
